import {
  WalletProviderPriority,
  getDefaultClient,
  getWalletProviderRegistry,
  hasExtension,
  registerExtension,
} from '@dynamic-labs-sdk/client/core';

import { registerBitcoinNetworkProviderBuilder } from '../../registerBitcoinNetworkProviderBuilder';
import { createWalletProviderForWaasBitcoin } from '../utils/createWalletProviderForWaasBitcoin';

export const WAAS_BITCOIN_EXTENSION_KEY = 'waasBitcoin';

/**
 * Adds the Dynamic WaaS (Wallet as a Service) Bitcoin extension to the Dynamic client.
 *
 * This extension enables embedded wallet functionality for Bitcoin blockchain,
 * allowing users to have wallets managed by Dynamic's infrastructure.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */
export const addWaasBitcoinExtension = (client = getDefaultClient()): void => {
  if (hasExtension({ extensionKey: WAAS_BITCOIN_EXTENSION_KEY }, client)) {
    return;
  }

  registerExtension({ extensionKey: WAAS_BITCOIN_EXTENSION_KEY }, client);
  registerBitcoinNetworkProviderBuilder(client);

  const walletProviderRegistry = getWalletProviderRegistry(client);

  const walletProvider = createWalletProviderForWaasBitcoin(client);

  walletProviderRegistry.register({
    priority: WalletProviderPriority.WALLET_SDK,
    walletProvider,
  });
};

